import { MdPersonAdd } from 'react-icons/md';
import { AppFab, AppButton } from '~components/AppCta';

export function JoinFab({ linkId }: { linkId: string }) {
  return (
    <AppFab path={`triby/${linkId}`} label="Join" rounded="lg" icon={<MdPersonAdd size={22} />} />
  );
}

export function JoinButton({ linkId }: { linkId: string }) {
  return (
    <AppButton
      path={`triby/${linkId}`}
      label="Join"
      rounded="lg"
      desktopOnly
      icon={<MdPersonAdd size={20} />}
    />
  );
}
